import React from "react";
import { Outlet } from "react-router-dom";

const Pages = () => {
  return <Outlet />;
};

export default Pages;
